import {
  OrganizationPublicId,
  MappingProgressEnum,
  ProcessingMethod,
  RequestHandlingInstructionType,
  UUIDString,
} from "../Types";

export interface RequestHandlingInstructionDto {
  id?: UUIDString;
  organizationId: OrganizationPublicId;
  requestType: RequestHandlingInstructionType;
  vendorId?: UUIDString;
  processingMethod?: ProcessingMethod;
  retentionReasons?: string[];
  processingInstructions?: string;
  doNotContact?: boolean;
  doNotContactReason?: DoNotContactReason;
  doNotContactExplanation?: string;
  exceptionsAffirmed?: boolean;
  deletedPIC?: string[];
  hasRetentionExceptions?: boolean;
}

export enum DoNotContactReason {
  CONTACT_VIA_OTHER_MEANS = "CONTACT_VIA_OTHER_MEANS",
  IMPOSSIBLE_OR_DIFFICULT = "IMPOSSIBLE_OR_DIFFICULT",
  SELF_SERVICE_REMOVAL = "SELF_SERVICE_REMOVAL",
  DEIDENTIFIED_DATA = "DEIDENTIFIED_DATA",
}

export const getDoNotContactReasonDefaultText = (reason: DoNotContactReason): string => {
  switch (reason) {
    case DoNotContactReason.CONTACT_VIA_OTHER_MEANS:
      return "Notification sent through other means";
    case DoNotContactReason.IMPOSSIBLE_OR_DIFFICULT:
      return "Extremely Difficult or Impossible to Contact";
    case DoNotContactReason.SELF_SERVICE_REMOVAL:
      return "Vendor Allows Self Service Removal";
    case DoNotContactReason.DEIDENTIFIED_DATA:
      return "Data stored with vendor is deidentified";
    default:
      // This is the default when they pick do not contact
      return "Vendor Allows Self Service Removal";
  }
};

export interface RequestHandlingInstructionEmbeddedDto {
  requestType: RequestHandlingInstructionType;
  processingMethod?: string;
  processingInstructions?: string;
  doNotContact?: boolean;
  hasRetentionExceptions?: boolean;
  doNotContactReason?: DoNotContactReason;
  doNotContactExplanation?: string;
}

export interface UpdateOrganizationInstructionsDto {
  organizationId: OrganizationPublicId;
  requestHandlingInstructions: string;
}

export interface RequestHandlingInstructionProgressDto {
  organizationId: OrganizationPublicId;
  collectionGroupProgress: MappingProgressEnum;
  knowProgress: MappingProgressEnum;
  deleteProgress: MappingProgressEnum;
  optOutProgress: MappingProgressEnum;
}
